import colorPalette from '../color-palette';

const { primary, success, action, background } = colorPalette;

export default {
  MuiToggleButton: {
    root: {
      boxShadow: `0px 1px 3px ${background.contrastShadow}`,
      border: `4px solid transparent`,
      margin: '8px',
      color: action.deselected,
      '&$selected': {
        backgroundColor: 'transparent',
        color: primary.main,
        border: `4px solid ${success.main}`,
        '&:active, &:hover': {
          backgroundColor: 'transparent',
        },
      },
      '&.Mui-disabled': {
        color: primary.mainDisabled,
        opacity: 0.5,
      },
    },
  },
};
